import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: '#154D93',
        stroke: '#51B5E5',
    },

    st1: {
        fill: '#022958',
    },

    st2: {
        clipPath: 'url(#SVGID_2_)',
    },

    st10: {
        fill: 'none',
    },

    st11: {
        fill: '#FFFFFF',
    },

    st12: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st13: {
        fontSize: '15px',
    },

}));
